import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  filterData: {},
  ispatientDetail: false,
  chatFilterData: {}, 
  isChatDetail: false 
}

const filterSlice = createSlice({
  name: 'filter',
  initialState,
  reducers: {
    getfilterData: (state, { payload }) => {
      state.filterData = payload;
    },
    togglePatientDetail: (state, { payload }) => {
      state.ispatientDetail = payload;
    },
    getChatFilterData: (state, { payload }) => { 
      state.chatFilterData = payload;
    },
    toggleChatDetail: (state, { payload }) => { 
      state.isChatDetail = payload;
    }
  } 
});

export const { 
  getfilterData, 
  togglePatientDetail, 
  getChatFilterData, 
  toggleChatDetail 
} = filterSlice.actions;

export default filterSlice.reducer;